import React from "react";
import { Card, CardContent } from "./ui/card";

const ClientsSection = () => {
  const clients = [
    { 
      name: "Barrick Gold", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/2o09v2to_barrick-white.svg"
    },
    { 
      name: "UEC Uranium Energy Corp", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/l0dl2txm_UEC-logo-white.svg"
    },
    { 
      name: "First Majestic Silver", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/5tl0p2ne_First_Majestic_Silver-white.svg"
    },
    { 
      name: "Faraday Copper", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/ubw6naoa_Faraday_Logo_white.svg"
    },
    { 
      name: "Metalla Royalty & Streaming", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/s87z3kfw_Metalla-white.svg"
    },
    { 
      name: "Guanajuato Silver", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/nj5szdow_gsilver-white.svg"
    },
    { 
      name: "Uranium Royalty Corp", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/e0bngfpn_urc-logo%20white.svg"
    },
    { 
      name: "Matador Mining", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/ua2xuv8a_Matador-White%20logo.svg"
    }
  ];

  const conferences = [
    {
      name: "PDAC",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/oeq9vq34_pdac.svg",
      larger: true
    },
    {
      name: "Cambridge House",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/x2ca0ohh_Cambridge%20House%20Logo.svg"
    },
    {
      name: "Deutsche Goldmesse", 
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/a0xk7i06_Deutshe-Goldmesse-horizontal-White.svg"
    },
    {
      name: "Gold Forum",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/340y9qtg_GoldForum.svg"
    },
    {
      name: "BMO Capital Markets",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/jltyvla7_BMO_DisplayBanner_300x250_E_FNL-02.svg"
    },
    {
      name: "Mines and Money",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/nyal83oy_Minesandmoney.svg"
    },
    {
      name: "Precious Metals Summit",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/8gpuacgk_Precious-Metals-Summit-LOGO.svg"
    },
    {
      name: "Silver and Gold Summit",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/vglhroeq_SilverandGoldsummit.svg"
    },
    {
      name: "SFP",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/ytsdxqaj_logo_sfp_h180.svg"
    },
    {
      name: "VRIC",
      logo: "https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/uo131gvt_VRIC_2024_logo-white-01.svg"
    }
  ];

  return (
    <section 
      id="clients" 
      className="py-20 relative"
      style={{
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url("https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/gdmufv7d_Conferences-Background.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'scroll'
      }}
    >
      <div className="container mx-auto px-4">
        {/* Conference Section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-yellow-500 mb-8">
            30+ Annual Conferences
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
            We provide comprehensive coverage and sponsorship opportunities at the industry's most important events
          </p>
          
          {/* Conference Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12">
            {conferences.map((conf, index) => (
              <Card key={index} className="bg-gray-800/50 border-yellow-500/20 hover:border-yellow-500/70 hover:shadow-[0_0_20px_rgba(244,185,66,0.3)] hover:bg-gray-800/70 transition-all duration-400 backdrop-blur-sm group hover:-translate-y-1 hover:scale-105 relative overflow-hidden before:absolute before:inset-0 before:bg-gradient-to-r before:from-yellow-500/10 before:to-transparent before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-400">
                <CardContent className="p-6 flex items-center justify-center h-24">
                  {conf.logo ? (
                    <img 
                      src={conf.logo}
                      alt={conf.name}
                      className={`max-w-full object-contain filter brightness-90 hover:brightness-110 transition-all ${
                        conf.larger ? 'max-h-16' : 'max-h-12'
                      }`}
                      onError={(e) => {
                        // Fallback to text if logo fails to load
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                  ) : null}
                  <div className={`text-yellow-500 font-bold text-sm text-center ${conf.logo ? 'hidden' : 'block'}`}>
                    {conf.name}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Clients Section */}
        <div className="text-center">
          <h2 className="text-4xl font-bold text-yellow-500 mb-8">
            Some of Our Clients
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
            Trusted by the world's leading mining companies and investment firms
          </p>

          {/* Client Logos Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-8 gap-4">
            {clients.map((client, index) => (
              <Card key={index} className="bg-gray-800/50 border-yellow-500/20 hover:border-yellow-500/40 transition-all duration-300 group backdrop-blur-sm">
                <CardContent className="p-4 flex items-center justify-center h-20">
                  {client.logo ? (
                    <img 
                      src={client.logo}
                      alt={client.name}
                      className="max-w-full max-h-12 object-contain transition-all duration-300 hover:opacity-80"
                      style={{ 
                        maxWidth: '140px'
                      }}
                      onError={(e) => {
                        // Fallback to text if logo fails to load
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                  ) : null}
                  <div className={`text-yellow-500 font-bold text-sm text-center group-hover:text-yellow-400 transition-colors ${client.logo ? 'hidden' : 'block'}`}>
                    {client.name.toUpperCase()}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;